import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import * as FullStory from '@fullstory/browser';

import { FullStoryService } from './services/full-story.service';

export interface FullStoryOptions extends FullStory.SnippetOptions {
  appName: string;
  environment: string;
  blacklistEmails?: string[];
  appHostUrl?: string;
}

export interface FullStorySession {
  app?: string;
  environment?: string;
  account?: string;
  program?: string;
}

export const FULLSTORY_OPTIONS = new InjectionToken<FullStoryOptions>('_FullStoryOptions', {
  factory: () => (window['env'] ? (window['env']['fullStory'] as FullStoryOptions) : null),
});

export const FULLSTORY = new InjectionToken<typeof FullStory>('_FullStory');

@NgModule({})
export class FullStoryModule {
  static forRoot(options: Partial<FullStoryOptions>): ModuleWithProviders<FullStoryModule> {
    const fsOptions = {
      orgId: 'o-1DZJB0-na1',
      appHostUrl: 'app.fullstory.com',
      ...options,
    };
    // Set the app host to override the relay proxy setting.
    // This setting is not exposed through the library.
    // tslint:disable-next-line: no-any
    (window as any)['_fs_app_host'] = fsOptions.appHostUrl;
    FullStory.init(fsOptions, (d) => console.log('FullStory readyCallback', d));
    if (options.debug || options.environment === 'local') {
      // tslint:disable-next-line: no-console
      console.debug('FullStory Initialized', { fsOptions });
    }
    return {
      ngModule: FullStoryModule,
      providers: [
        { provide: FULLSTORY, useValue: FullStory },
        { provide: FULLSTORY_OPTIONS, useValue: options },
        FullStoryService,
      ],
    };
  }
  static forTesting(): ModuleWithProviders<FullStoryModule> {
    return {
      ngModule: FullStoryModule,
      providers: [FullStoryService, { provide: FULLSTORY_OPTIONS, useValue: {} }],
    };
  }
}
